import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

// Same blur + overlay treatment as the removed per-card ProGate pattern
// (see AnalysisResult.jsx git history, commit bed14c0: filter blur(4px) +
// pointerEvents none + userSelect none on the gated content, a translucent
// white wash on top). Used here to gate a whole page instead of one card,
// wrapping the real page component rather than replacing it, so the page
// stays fully intact underneath.
//
// The overlay is `position: fixed` (not `absolute` like the original
// per-card version) so it always covers the full viewport regardless of
// scroll position — the right choice at page scope, where content height
// can exceed the viewport and the gated page's own sticky header would
// otherwise be visible again once scrolled past an absolute overlay.
export default function ComingSoonGate({ children, message }) {
  const { user } = useAuth();
  // The dev admin account (server.py ADMIN_BYPASS_EMAIL) sees every feature
  // unrestricted, including ones not yet launched to regular users.
  if (user?.auth_methods?.includes("admin_bypass")) return <>{children}</>;
  return (
    <div style={{ position: "relative" }} data-testid="coming-soon-gate">
      <div style={{ filter: "blur(4px)", pointerEvents: "none", userSelect: "none" }} aria-hidden="true">
        {children}
      </div>
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 50,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(255,255,255,0.85)",
          padding: 24,
          textAlign: "center",
        }}
        data-testid="coming-soon-overlay"
      >
        <div style={{ fontSize: 15, fontWeight: 700, color: "#1a1a18" }}>Coming soon</div>
        <p style={{ fontSize: 13, color: "#5f5e5a", margin: "8px 0 16px", maxWidth: 340, lineHeight: 1.5 }}>
          {message}
        </p>
        <Link
          to="/dashboard"
          data-testid="coming-soon-back"
          style={{
            background: "#1D9E75",
            color: "white",
            borderRadius: 8,
            padding: "8px 18px",
            fontSize: 13,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
